import { createSelector } from "@reduxjs/toolkit";
import { initialGeoRegion } from "../../../../components/helpers";
import { IfilterObj } from "../../types";
import { encode as base64Encode } from "base-64";
import { AppState } from "../../..";

const NO_MATCH_LABEL_VALUE = "__NO_MATCH_LABEL__";

export const geoRegionSelector = createSelector(
    [(state) => state.labelDeviceFilter.geoRegion],
    (region) => region || initialGeoRegion
);

export const addDeviceGeoRegionSelector = createSelector(
    [(state) => state.labelDeviceFilter.addDeviceGeoRegion],
    (region) => region || initialGeoRegion
);


export const labelNameSelector = (state: AppState) => state.labelDeviceFilter.labelName;
export const siteGroupSelector = (state: AppState) => state.labelDeviceFilter.siteGroup;
export const isLabelDeviceAssociationProgressSelector = (state: AppState) => state.labelDeviceFilter.isLabelDeviceAssociationProgress || false;
export const addDeviceSiteGroupSelector = (state: AppState) => state.labelDeviceFilter.addDeviceSiteGroup;
export const isAssociatedDevicesRemovedSelector = (state: AppState) => state.labelDeviceFilter.isAssociatedDevicesRemoved || false;

export const urlParameterSelector = createSelector(
    siteGroupSelector,
    addDeviceSiteGroupSelector,
    geoRegionSelector,
    addDeviceGeoRegionSelector,
    labelNameSelector,
    isLabelDeviceAssociationProgressSelector,

    (siteGroup, addDeviceSiteGroup, geoRegionName, geoAddDeviceRegionName, labelName, isLabelDeviceAssociationProgress) => {
        const params = new URLSearchParams();
        const paramsString: IfilterObj = { type: "AND", operator: "", fieldName: "", value: "", predicates: [] };
        const hasValidLabel = !!labelName?.value && labelName.value !== "NONE";
        const labelValue = hasValidLabel ? labelName.value : NO_MATCH_LABEL_VALUE;

        if (isLabelDeviceAssociationProgress) {
            if (geoAddDeviceRegionName && geoAddDeviceRegionName.name) {
                paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "geoRegionName", value: geoAddDeviceRegionName.name, predicates: [{}] });
            }

            if (addDeviceSiteGroup) {
                paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "siteGroupName", value: addDeviceSiteGroup, predicates: [{}] });
            }
        } else {
            if (geoRegionName && geoRegionName.name) {
                paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "geoRegionName", value: geoRegionName.name, predicates: [{}] });
            }

            if (siteGroup) {
                paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "siteGroupName", value: siteGroup, predicates: [{}] });
            }
        }

        if (!hasValidLabel) {
            paramsString.predicates.push({
                type: "",
                operator: "EQUAL",
                fieldName: "labelNames",
                value: NO_MATCH_LABEL_VALUE,
                predicates: [{}],
            });
        } else if (isLabelDeviceAssociationProgress) {
            paramsString.predicates.push({
                type: "OR",
                operator: "",
                fieldName: "",
                value: "",
                predicates: [
                    {
                        type: "",
                        operator: "NOT_LIKE",
                        fieldName: "labelNames",
                        value: `%${labelValue}%`,
                        predicates: [{}],
                    },
                    {
                        type: "",
                        operator: "IS_NULL",
                        fieldName: "labelNames",
                        value: "",
                        predicates: [{}],
                    }
                ]
            });
        } else {
            paramsString.predicates.push({ type: "", operator: "LIKE", fieldName: "labelNames", value: `%${labelValue}%`, predicates: [{}] });
        }

        const base64EncodedStr = base64Encode(JSON.stringify(paramsString));
        if (paramsString?.predicates.length > 0) {
            base64EncodedStr && params.append("filters", base64EncodedStr);
        }

        return params;
    }
);


export const urlRemoveParameterSelector = createSelector(
    siteGroupSelector,
    addDeviceSiteGroupSelector,
    geoRegionSelector,
    addDeviceGeoRegionSelector,
    labelNameSelector,
    isLabelDeviceAssociationProgressSelector,

    (siteGroup, addDeviceSiteGroup, geoRegionName, geoAddDeviceRegionName, labelName, isLabelDeviceAssociationProgress) => {
        const params = new URLSearchParams();
        const paramsString: IfilterObj = { type: "AND", operator: "", fieldName: "", value: "", predicates: [] };
        const hasValidLabel = !!labelName?.value && labelName.value !== "NONE";
        const labelValue = hasValidLabel ? labelName.value : NO_MATCH_LABEL_VALUE;

        if (geoRegionName && geoRegionName.name) {
            paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "geoRegionName", value: geoRegionName.name, predicates: [{}] });
        }

        if (siteGroup) {
            paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "siteGroupName", value: siteGroup, predicates: [{}] });
        }

        paramsString.predicates.push(
            hasValidLabel
                ? { type: "", operator: "LIKE", fieldName: "labelNames", value: `%${labelValue}%`, predicates: [{}] }
                : { type: "", operator: "EQUAL", fieldName: "labelNames", value: NO_MATCH_LABEL_VALUE, predicates: [{}] }
        );

        const base64EncodedStr = base64Encode(JSON.stringify(paramsString));
        if (paramsString?.predicates.length > 0) {
            base64EncodedStr && params.append("filters", base64EncodedStr);
        }

        return params;
    }
);

export const urlAddParameterSelector = createSelector(
    siteGroupSelector,
    addDeviceSiteGroupSelector,
    geoRegionSelector,
    addDeviceGeoRegionSelector,
    labelNameSelector,
    isLabelDeviceAssociationProgressSelector,

    (siteGroup, addDeviceSiteGroup, geoRegionName, geoAddDeviceRegionName, labelName, isLabelDeviceAssociationProgress) => {
        const params = new URLSearchParams();
        const paramsString: IfilterObj = { type: "AND", operator: "", fieldName: "", value: "", predicates: [] };
        const hasValidLabel = !!labelName?.value && labelName.value !== "NONE";
        const labelValue = hasValidLabel ? labelName.value : NO_MATCH_LABEL_VALUE;



        if (geoAddDeviceRegionName && geoAddDeviceRegionName.name) {
            paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "geoRegionName", value: geoAddDeviceRegionName.name, predicates: [{}] });
        }

        if (addDeviceSiteGroup) {
            paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "siteGroupName", value: addDeviceSiteGroup, predicates: [{}] });
        }

        if (hasValidLabel) {
            paramsString.predicates.push({
                type: "OR",
                operator: "",
                fieldName: "",
                value: "",
                predicates: [
                    {
                        type: "",
                        operator: "NOT_LIKE",
                        fieldName: "labelNames",
                        value: `%${labelValue}%`,
                        predicates: [{}],
                    },
                    {
                        type: "",
                        operator: "IS_NULL",
                        fieldName: "labelNames",
                        value: "",
                        predicates: [{}],
                    }
                ]
            });
        } else {
            paramsString.predicates.push({
                type: "",
                operator: "EQUAL",
                fieldName: "labelNames",
                value: NO_MATCH_LABEL_VALUE,
                predicates: [{}],
            });
        }

        const base64EncodedStr = base64Encode(JSON.stringify(paramsString));
        if (paramsString?.predicates.length > 0) {
            base64EncodedStr && params.append("filters", base64EncodedStr);
        }

        return params;
    }
);